module.exports = __webpack_public_path__ + "static/media/mini-announcements.c4950ea2.svg";